import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setInventoryitemSorting} from 'store/slice/ManufSlice';

export default function InventoryitemListTableHeader(){
  const {mobileView} = useSelector((state)=>state.menu);
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.manufslice.inventoryitemDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setInventoryitemSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
            
            <Grid item lg={2} xs={3} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('type')}> Party Name </Typography></Grid>
            {mobileView?<></>:
            <>
            <Grid item lg={1} xs={3} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('type')}> Order # </Typography></Grid>
            <Grid item lg={2} xs={2} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('type')}> Date </Typography></Grid>
            </>
            
            }       
            <Grid item lg={1} xs={3} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('creditcount')}> Credit </Typography></Grid>
            <Grid item lg={1} xs={3} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('debitcount')}> Debit </Typography></Grid>
            <Grid item lg={1} xs={3} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('balance')}> Balance </Typography></Grid>
            <Grid item lg={2} xs={3} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('balance')}> Reason </Typography></Grid>
            

      </Grid>
      
    )
}